exports.version = "1.2.2"


//////////////////
// WEBPACK FOOTER
// ../~/apollo-client/version.js
// module id = 1297
// module chunks = 0